import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    redirection: false,
    otp: false,
    error: null,
    success: false,
    verificationSuccess:false,
    token: {
        xToken: '',
    },
    savedPreferences:null,
    preferences:null,
    notifications:null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        checkEmailRequest: (state, action: PayloadAction<string>) => {
            state.isLoading = true;
            state.error = null;
        },
        checkEmailSuccess: (state, action) => {
            state.isLoading = false;
            state.redirection = action.payload.redirection;
            state.otp = action.payload.otp;
        },
        checkEmailFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        verifyOtpRequest: (state, action: PayloadAction<{ email: string; otp: string }>) => {
            state.isLoading = true;
            state.error = null;
            state.otp = false;
        },
        verifyOtpSuccess: (state) => {
            state.isLoading = false;
            state.otp = true;
            state.error = null;
        },
        verifyOtpFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.otp = false;
        },
        setOtpSuccess: (state, action: PayloadAction<boolean>) => {
            state.success = action.payload;
        },
        setToken: (state, action: PayloadAction<{ xToken: string }>) => {
            state.token.xToken = action.payload.xToken;
        },
        fetchPrefandNotifsRequest:(state) => {
            state.isLoading = true;
            state.error=null;
        },
        fetchPrefandNotifsSuccess:(state,action) => {
            state.isLoading=false;
            state.preferences = action.payload.preferences;
            state.notifications = action.payload.notifications;
        },
        fetchPrefandNotifsFailure:(state,action) => {
            state.isLoading=false;
            state.error=action.payload;
        },
        savePreferrenceRequest:(state,action) => {
            state.isLoading=true;
            state.error=null;
        },
        savePreferrenceSuccess:(state) => {
            state.isLoading=false;
            state.verificationSuccess=true;
        },
        savePreferrenceFailure:(state,action) => {
            state.isLoading=false;
            state.error=action.payload;
        },
        fetchPreferencesRequest:(state,action) => {
            state.isLoading=true;
            state.error = null ;
        },
        fetchPreferencesSuccess:(state,action) => {
            state.isLoading=false;
            state.savedPreferences = action.payload;
        },
        fetchPreferencesFailure:(state,action) => {
            state.isLoading=false;
            state.error = action.payload;
        },
        resetOtp:(state) => {
            state.otp=false;
            state.success=false;
        },
        resetRedirectionAndOtp: (state) => {
            state.redirection = false;
            state.otp = false;
            state.success = false;
            state.verificationSuccess = false;
        }
    }
});

export const { checkEmailRequest,
    checkEmailFailure,
    checkEmailSuccess,
    verifyOtpFailure,
    verifyOtpRequest,
    verifyOtpSuccess,
     setOtpSuccess,
     setToken,
     fetchPrefandNotifsFailure,
     fetchPrefandNotifsRequest,
     fetchPrefandNotifsSuccess,
    savePreferrenceFailure,
savePreferrenceRequest,
savePreferrenceSuccess,
fetchPreferencesFailure,
fetchPreferencesRequest,
fetchPreferencesSuccess,
resetRedirectionAndOtp,
resetOtp } = userSlice.actions;
export default userSlice.reducer;